<template>
    <div class="settings-card">
        <div class="card-header">
            <h2>Notifications (WIP)</h2>
        </div>
        <div class="card-content">
            <div class="setting-row">
                <div class="setting-info">
                    <label class="setting-label">Enable Notifications</label>
                    <span class="setting-description">
                        Receive updates about your progress and achievements
                    </span>
                </div>
                <div class="toggle-wrapper">
                    <label class="toggle-switch">
                        <input
                            type="checkbox"
                            :checked="enabled"
                            @change="$emit('update:enabled', $event.target.checked)"
                        />
                        <span class="toggle-slider"></span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotificationsCard',
    props: {
        enabled: {
            type: Boolean,
            default: true
        }
    },
    emits: ['update:enabled']
};
</script>

<style scoped>
.settings-card {
    background: var(--bg-primary);
    border: 1px solid rgba(var(--accent-rgb), 0.6);
    overflow: hidden;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 30px;
    background: var(--bg-secondary);
    border-bottom: 1px solid var(--accent);
}

.card-header h2 {
    margin: 0;
    color: var(--text-secondary);
    font-size: 24px;
}

.card-content {
    padding: 30px;
}

.setting-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}

.setting-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.setting-label {
    color: var(--text-secondary);
    font-size: 16px;
    font-weight: 500;
}

.setting-description {
    color: rgba(var(--text-primary-rgb), 0.6);
    font-size: 14px;
    line-height: 1.4;
}

.toggle-wrapper {
    display: flex;
    align-items: center;
}

.toggle-switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
    cursor: pointer;
}

.toggle-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.toggle-slider {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--bg-primary);
    transition: 0.3s;
    border-radius: 34px;
    border: 2px solid var(--accent);
}

.toggle-slider:before {
    position: absolute;
    content: "";
    height: 24px;
    width: 24px;
    left: 3px;
    bottom: 3px;
    background-color: var(--accent);
    transition: 0.3s;
    border-radius: 50%;
}

input:checked + .toggle-slider {
    background-color: var(--bg-primary);
    border-color: var(--accent);
}

input:checked + .toggle-slider:before {
    transform: translateX(26px);
    background-color: var(--accent);
}

@media (max-width: 768px) {
    .card-header {
        padding: 15px 20px;
    }

    .card-content {
        padding: 20px;
    }

    .setting-row {
        flex-direction: column;
        align-items: flex-start;
    }

    .toggle-wrapper {
        align-self: flex-end;
    }
}
</style>
